
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#2a3a2f] text-white pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://public.readdy.ai/ai/img_res/bb5b4f5c-6921-444f-be70-983bff8d900a.png"
                alt="청주 아이폰수리 마켓"
                className="h-10 w-auto object-contain"
              />
            </div>
            <h3 className="text-xl font-bold mb-4">청주 아이폰수리 마켓</h3>
            <div className="space-y-2 text-sm text-gray-400">
              <p>iPhone, iPad 전문 수리</p>
              <p>정품 부품 사용 보증</p>
              <p>15년 경력의 신뢰</p>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase text-gray-400 mb-4 tracking-wider">바로가기</h4>
            <div className="space-y-3">
              <button
                onClick={() => scrollToSection('services')}
                className="block text-sm text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
              >
                수리 서비스
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="block text-sm text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
              >
                회사 소개
              </button>
              <button
                onClick={() => scrollToSection('faq')}
                className="block text-sm text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
              >
                자주 묻는 질문
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase text-gray-400 mb-4 tracking-wider">문의하기</h4>
            <div className="space-y-3">
              <a
                href="tel:010-3000-2020"
                className="block text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
              >
                010-3000-2020
              </a>
              <button
                onClick={() => scrollToSection('contact')}
                className="block text-sm text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
              >
                상담 신청
              </button>
              <a
                href="https://open.kakao.com/o/sMCniBii"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#FEE500] text-[#3A1D1D] text-sm font-bold px-4 py-2 rounded-full hover:bg-[#f5dc00] transition-colors cursor-pointer whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-kakao-talk-fill text-base"></i>
                </span>
                카카오톡 문의
              </a>
              <a
                href="https://blog.naver.com/roy1967"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
              >
                네이버 블로그
              </a>
              <a
                href="https://maps.google.com/?q=청주시+상당구+성안로+19-5"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
              >
                오시는 길
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase text-gray-400 mb-4 tracking-wider">위치</h4>
            <div className="text-sm text-gray-300 space-y-2">
              <p>청주시 상당구 성안로 19-5</p>
              <p className="text-gray-400">(성안길 다이소 입구 앞)</p>
              <p className="mt-4 text-gray-400">사업자: 223-07-51528</p>
            </div>
          </div>
        </div>

        <div className="relative mb-12 overflow-hidden">
          <div className="text-[120px] md:text-[160px] font-bold text-[#E8E4D9] leading-none tracking-tighter">
            IPHONE REPAIR
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500 text-center md:text-left">
            사업자번호: 223-07-51528 | 청주시 상당구 성안로 19-5
          </p>
          <p className="text-xs text-gray-500">
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-400 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
